
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
/** Generic call-to-action button (`<cta>` in templates). Supports outline states for use as a filter chip (`selectable`/`checkable` + `active`). */
export default class Button extends Vue {
  @Prop({ default: "primary" }) variant!: string;
  @Prop({ default: false }) block!: boolean;
  @Prop({ default: false }) small!: boolean;
  @Prop({ default: false }) large!: boolean;
  @Prop({ default: false }) round!: boolean;
  @Prop({ default: false }) selectable?: boolean;
  @Prop({ default: false }) checkable?: boolean;
  @Prop({ default: false }) active?: boolean;
  @Prop({ default: false }) disabled?: boolean;
}
